/** User-owned named deployment snapshot. Phase 1: localStorage; Phase 2: account API. */
export type SavedDeploymentConfigKind = "container" | "vm";

export const SAVED_DEPLOYMENT_CONFIG_SCHEMA_VERSION = 1 as const;

export type SavedHardwareHints = {
  hardwareId?: string;
  hardwareName?: string;
  location?: string;
  supplier?: string;
  numCards?: number;
};

/**
 * Allowlisted Formik fields (plus hardware hints) stored in a saved config.
 * Dynamic env keys (`env_normal_*` / `env_private_*`) are included via index signature.
 */
export type SavedDeploymentConfigPayload = SavedHardwareHints & {
  name?: string;
  hardware?: string;
  hardwareQuantity?: number;
  locations?: string[];
  supplier?: string;
  durationType?: string;
  durationQuantity?: number;
  // Container
  containerImage?: string;
  containerRecipe?: string;
  isPrivate?: boolean;
  username?: string;
  secret?: string;
  command?: string;
  trafficPort?: number;
  healthCheckPath?: string;
  healthCheckIntervalSeconds?: number;
  healthCheckTimeoutSeconds?: number;
  healthCheckGracePeriodSeconds?: number;
  gpusPerContainer?: number;
  gpuUnavailabilityPolicy?: string;
  replicaCount?: string;
  // VM
  vmImageType?: string;
  isConfidentialCompute?: boolean;
  sshType?: string;
  /** Legacy — full key snapshots; new configs use selectedSshKeyIds only. */
  sshKeys?: { id: string; key: string; value: string }[];
  /** Account SSH key IDs checked for deploy. */
  selectedSshKeyIds?: string[];
  githubIds?: string;
  networkServices?: {
    id: string;
    name: string;
    port: number;
    protocol: "tcp" | "udp";
    whitelistIps: string[];
  }[];
  [envKey: string]: unknown;
};

export type SavedDeploymentConfig = {
  id: string;
  name: string;
  kind: SavedDeploymentConfigKind;
  schemaVersion: typeof SAVED_DEPLOYMENT_CONFIG_SCHEMA_VERSION;
  createdAt: string;
  updatedAt: string;
  payload: SavedDeploymentConfigPayload;
};

export type SavedDeploymentConfigStorage = {
  version: 1;
  byUserId: Record<string, SavedDeploymentConfig[]>;
};
